module.exports = __webpack_public_path__ + "./AdamPhoto_de91a80e1d000204d4dd3eb5c22e6092.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/AdamPhoto.png
// module id = 515
// module chunks = 0